import CurrentGiftsItem from './CurrentGiftsItem';
export default CurrentGiftsItem;
